import { Store } from "@ngrx/store";
import { Injectable } from "@angular/core";
import { SousDocumentation } from "./sousdocumentation.model";
import {
    ISousDocumentationState,
    sousdocumentationFacadeBase,
} from "./sousdocumentation.state";
import { SousDocumentationService } from "./sousdocumentation.service";
import { Observable } from "rxjs";

@Injectable()
export class SousDocumentationFacade extends sousdocumentationFacadeBase {
    constructor(
        _store: Store<ISousDocumentationState>,
        private _sousdocumentationService: SousDocumentationService
    ) {
        super(SousDocumentation, _store);
    }
    getSousDocumentationByName(name: string): Observable<SousDocumentation> {
        return this._sousdocumentationService.getSousDocumentationByName(name);
    }
  
}
